<template>
  <div class="set-title">
    <el-dialog
        :title="title"
        :visible="true"
        @close="handleClose"
        width="460px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="警告词" prop="name">
          <el-input size="small" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="enabled">
          <el-switch
            active-value="1"
            inactive-value="0"
            v-model="ruleForm.enabled"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label-width="0">
          <div style="display: flex;justify-content: center;">
            <el-button size="small" type="info" @click="handleClose()">关闭</el-button>
            <el-button size="small" type="primary" @click="submitForm('ruleForm')">确定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ShopDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      ruleForm: {
        name: '',
        remark: '',
        enabled: '1',
      },
      rules: {
        name: [
          {required: true, message: '请输入警告词', trigger: 'blur'},
        ],
      }
    }
  },
  mounted() {
    if(this.title === '编辑'){
      this.ruleForm = {...this.row}
      console.log(this.row)
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.ruleForm
          }
          if(this.title === '新增'){
            const res = await this.$http.post('keywordBlacklist/saveAction', params);
            if(res.data.code == 200){
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              this.$options.confirm(true)
            }else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
            }
          }
          if(this.title === '编辑'){
            const res = await this.$http.post('keywordBlacklist/updateAction', params);
            if(res.data.code == 200){
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              this.$options.confirm(true)
            }else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
            }
          }
          // this.$options.confirm(true)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>
<style scoped lang="less">
.set-title {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .el-dialog__body{
    padding-top: 10px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
  ::v-deep .el-input-number--medium {
    width: 100%;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
  .w100{
    width: 100%;
    position: relative;
    span{
      position: absolute;
      top: 0;
      right: 10px;
    }
  }
  .w50{
    display: flex;
    width: 49%;
    position: relative;
    span{
      position: absolute;
      top: 0;
      right: 10px;
    }
  }
}
</style>